import { Component, ViewChild, ElementRef } from '@angular/core';
import { distinctUntilChanged, takeUntil, filter } from 'rxjs/operators';
import { devices } from '../../config/devices';
import { ElectronicsDevice } from '../../models/electronics-device';
import { TableData } from '@models/table-data';
import { PRICE_UP_TO_2500 } from '@config/error-messages.const';
import { damagesTable } from '../../config/damages-table';
import ElectronicsLandingBase from '../electronics-landing-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ElectronicsB2CDeviceCardComponent } from '../../components/electronics-b2c-device-card/electronics-b2c-device-card.component';
import { InfoTooltipComponent } from 'app/shared/components/info-tooltip/info-tooltip.component';
import { CtrlErrorMessageDirective } from '@co-3/ctrl-ui/forms';
import { RequiredInfoComponent } from 'app/shared/components/required-info/required-info.component';
import { VariantsFieldsetComponent } from '../../components/variants-fieldset/variants-fieldset.component';
import { PriceDisplayCardComponent } from 'app/order/components/price-display-card/price-display-card.component';
import { CollapsibleTableComponent } from 'app/shared/components/collapsible-table/collapsible-table.component';
import { FaqElectronicsB2CComponent } from '../../components/faq-electronics-b2c/faq-electronics-b2c.component';
import { PriceInputDirective } from 'app/shared/directives/price-input.directive';
import { SuspendEnterDirective } from 'app/shared/directives/suspend-enter.directive';

@Component({
    selector: 'app-electronics-b2c-landing',
    templateUrl: './electronics-b2c-landing.component.html',
    styleUrl: './electronics-b2c-landing.component.scss',
    imports: [
        ReactiveFormsModule,
        ElectronicsB2CDeviceCardComponent,
        InfoTooltipComponent,
        CtrlErrorMessageDirective,
        RequiredInfoComponent,
        VariantsFieldsetComponent,
        PriceDisplayCardComponent,
        CollapsibleTableComponent,
        FaqElectronicsB2CComponent,
        PriceInputDirective,
        SuspendEnterDirective,
    ],
})
export class ElectronicsB2CLandingComponent extends ElectronicsLandingBase {
    @ViewChild('priceContainer', { read: ElementRef }) public priceContainer: ElementRef;

    public valueErrorMessage = PRICE_UP_TO_2500;

    public devices: ElectronicsDevice[] = [...devices];
    public damagesTable: TableData = damagesTable;

    public get selectedDevice(): ElectronicsDevice | null {
        return this.devices.find((item) => item.name === this.form.get('type')?.value) ?? null;
    }

    public constructor() {
        super();
        this.initForm('Smartphone');
        this.subscribeForTypeChange();
    }

    private subscribeForTypeChange(): void {
        this.form
            .get('type')
            .valueChanges.pipe(
                distinctUntilChanged(),
                filter((value) => value !== null),
                takeUntil(this.unsubscribe$),
            )
            .subscribe(() => {
                setTimeout(() => {
                    window.scrollTo({
                        top: (this.priceContainer.nativeElement as HTMLElement).offsetTop - 120,
                        behavior: 'smooth',
                    });
                });
            });
    }
}
